$(function(){

	var csrftoken = Cookies.get('csrftoken');

    var Currency = {
    	config: {
    		endpoint: '',
    		btn: '',
    	},
        send: function(data) {
            var that = this;
            $.ajax({
                type: "POST",
                url: that.config.endpoint,
                headers: {
                    'X-CSRFToken': csrftoken
                },
                data: data,
                success: function(){
                    location.reload();
                }
            })
        },
        init: function(config) {
        	this.config = config;
            var that = this;
            this.config.btn.bind('click', function() {
                console.log(this)
                var currencyCode = $(this).data('currency')
                console.log(currencyCode)
                that.send({
                	code: currencyCode,
                })
            });
        }
    };

    Currency.init({
		endpoint: '/api/v1/currencies',
		btn: $('.js-currency'),
    })




})